import { createResetStateMutation } from '@/helpers';
import { getInitialStateClient } from './state';

export const setCliente = (state, payload) => {
   state.cliente = {
      ...state.cliente,
      id_cliente: payload.id_cliente,
      cuit: payload.cuit,
      nombre: payload.nombre,
      localidad: payload.localidad,
      id_localidad: payload.id_localidad,
      domicilio: payload.domicilio,
      provincia: payload.provincia,
      codigo_postal: payload.codigo_postal,
      id_condicion_fiscal: payload.id_condicion_fiscal,
      email: payload.email || '',
      telefono: payload.telefono || '',
      apellido: payload.apellido || '',
      razonSocial: payload.razonSocial || '',
      tipo_persona: payload.tipo_persona || null,
      sexo: payload.sexo || '',
      fechaNacimiento: payload.fecha_nacimiento ?? null,
      actividad: payload.actividad ?? null,
      iibb: payload.iibb ?? null,
   };
};

export const setReferente = (state, payload) => {
   state.referente = {
      ...state.referente,
      cuit: payload.cuit,
      nombre: payload.nombre,
      email: payload.email || '',
      telefono: payload.telefono || '',
      observaciones: payload.observaciones || '',
   };
};

export const updateRef = (state, { key, value }) => {
   state.referente[key] = value;
};

export const updateCli = (state, { key, value }) => {
   state.cliente[key] = value;
};

export const resetState = createResetStateMutation(getInitialStateClient);
